
import { createCSVRow, generateCSVHeaders } from '../utils/csvContentUtils';

/**
 * Generate CSV content for recommendations data
 */
export const generateRecommendationsCSV = (data: any): string => {
  // Create headers for recommendations
  const headers = ["Title", "Description", "Impact", "Difficulty"];
  let csvContent = generateCSVHeaders(headers);
  
  // Add data rows for recommendations
  data.data.forEach((item: any) => {
    let row = [
      item.title || '',
      item.description || '',
      item.impact || '',
      item.difficulty || ''
    ];
    
    csvContent += createCSVRow(row);
  });
  
  return csvContent;
};
